var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.50001C12.75 2.53938 15.5827 1.02766 21.75 1.00001C21.8486 0.999633 21.9463 1.01878 22.0375 1.05634C22.1286 1.0939 22.2114 1.14913 22.2812 1.21885C22.3509 1.28856 22.4061 1.37139 22.4437 1.46255C22.4812 1.55372 22.5004 1.65141 22.5 1.75001V15.25C22.5 15.4489 22.421 15.6397 22.2803 15.7803C22.1397 15.921 21.9489 16 21.75 16C15.75 16 13.432 17.2099 12 19C10.5764 17.2188 8.25 16 2.25001 16C1.78688 16 1.50001 15.6227 1.50001 15.1595V1.75001C1.49963 1.65141 1.51878 1.55372 1.55634 1.46255C1.5939 1.37139 1.64913 1.28856 1.71885 1.21885C1.78856 1.14913 1.87139 1.0939 1.96255 1.05634C2.05372 1.01878 2.15141 0.999633 2.25001 1.00001C8.41735 1.02766 11.25 2.53938 12 5.50001ZM12 5.50001V19V5.50001Z",
    fill: "#796DEC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.50001C12.75 2.53938 15.5827 1.02766 21.75 1.00001C21.8486 0.999633 21.9463 1.01878 22.0375 1.05634C22.1286 1.0939 22.2114 1.14913 22.2812 1.21885C22.3509 1.28856 22.4061 1.37139 22.4437 1.46255C22.4812 1.55372 22.5004 1.65141 22.5 1.75001V15.25C22.5 15.4489 22.421 15.6397 22.2803 15.7803C22.1397 15.921 21.9489 16 21.75 16C15.75 16 13.432 17.2098 12 19M12 5.50001C11.25 2.53938 8.41735 1.02766 2.25001 1.00001C2.15141 0.999633 2.05372 1.01878 1.96255 1.05634C1.87139 1.0939 1.78856 1.14913 1.71885 1.21885C1.64913 1.28856 1.5939 1.37139 1.55634 1.46255C1.51878 1.55372 1.49963 1.65141 1.50001 1.75001V15.1595C1.50001 15.6227 1.78688 16 2.25001 16C8.25 16 10.5764 17.2188 12 19M12 5.50001V19",
    stroke: "#796DEC",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 7H20",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9H20",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 11H20",
    stroke: "white",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.30939fc6b23ec115136e23df4f1275c8.svg";
export { ForwardRef as ReactComponent };